import { Body, Heading } from '@assembly-js/design-system';

import { Note } from 'src/services/api/notesApi';
import { DateUtils } from 'src/utils';

export const NotesListItem = ({
  note,
  isUpdating = false,
  onClick,
}: {
  note: Note;
  isUpdating?: boolean;
  onClick: () => void;
}) => {
  const isSaving = note.id.startsWith('temp-') || isUpdating;

  return (
    <button
      className="appearance-none bg-transparent p-0 w-full text-left hover:cursor-pointer px-4 hover:bg-secondary-hover disabled:hover:bg-transparent border-non-hover-border border-solid border-l-0 border-r-0 border-t-0 border-b disabled:cursor-default"
      onClick={onClick}
      disabled={isSaving}
      aria-label={
        isSaving ? `Note "${note.title}" is saving, please wait` : undefined
      }
    >
      <div className="w-full h-full py-2 flex items-baseline gap-2">
        <Heading
          size="sm"
          className={
            isSaving
              ? 'flex-1 min-w-0 wrap-break-word bg-linear-to-r from-black-heading via-gray-300 to-black-heading bg-clip-text text-transparent bg-size-[200%_100%] animate-shimmer'
              : 'flex-1 min-w-0 text-black-heading wrap-break-word'
          }
        >
          {note.title}
        </Heading>
        <Body size="xs" className="text-secondary shrink-0">
          {DateUtils.formatDate(note.createdAt)}
        </Body>
      </div>
    </button>
  );
};
